module.exports = __webpack_public_path__ + "img/tl.aa09b3db.svg";